// extracted by mini-css-extract-plugin
export default {"userPhoto":"Users_userPhoto__PeBTK"};